let address = `https://${process.env.VUE_APP_BASE}vip.zhibo.tv`
let address1 = `https://${process.env.VUE_APP_BASE}www.zhibo.tv`
let address2 = `https://${process.env.VUE_APP_BASE}rest.zhibo.tv`
let address3 = `https://${process.env.VUE_APP_BASE}v.zhibo.tv`
let address4 = `https://api.weibo.com`
const ADDRESS = {address,address1,address2,address3,address4}
export{
  ADDRESS
}